export default {
  tokenId: "",
  tokenInfo: null,
  queryAnswer: null,
  reloadPage: false,
  showError: false,
  errorMsg: null,
  theme: null,
  curBlockHeight: 0,
  toLoadMore: false,
  hasMore: false,
  loadingData: false
};
